import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useEffect} from 'react'
import {useSearchParams} from '@github-ui/react-router'
import {savedViewRouteId} from '@github-ui/saved-views'
import {getItemById} from '@github-ui/shared-dashboard-surface/helpers/layout-helpers'
import {getDefaultView} from '@github-ui/shared-dashboard-surface/hooks/use-save-default-view'
import {useNavigate} from '@github-ui/use-navigate'
import {ISSUES_DASHBOARD_SEARCH_PATH} from '../constants/routes'
import {useIssuesDashboardSurfaceStateContext} from '../contexts/IssuesDashboardSurfaceStateContext'
import {issuesDashboardSurfaceContentRoute} from './issues-dashboard-surface-content-route'

/**
 * Index-route gate for /issues.
 * - /issues?q=xxx  → redirects to /issues/search?q=xxx
 * - /issues        → redirects to the user's default view, defaulting to assigned
 */
export function IssuesDashboardIndexGate() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hasQuery = searchParams.has('q')
  const {payload} = useIssuesDashboardSurfaceStateContext()
  const defaultViewId = isFeatureEnabled('issues_dashboard_default_view')
    ? (getDefaultView('issues') ?? payload.defaultViewId)
    : undefined
  const defaultView = getItemById(defaultViewId ?? 'assigned', payload.savedViews, payload.sidebarLinks)
  const defaultViewMode = defaultView?.path ?? (defaultView ? savedViewRouteId(defaultView) : 'assigned')

  useEffect(() => {
    if (hasQuery) {
      navigate({pathname: ISSUES_DASHBOARD_SEARCH_PATH, search: searchParams.toString()}, {replace: true})
      return
    }

    navigate({pathname: issuesDashboardSurfaceContentRoute.generatePath({mode: defaultViewMode})}, {replace: true})
  }, [defaultViewMode, hasQuery, navigate, searchParams])

  return null
}
